import { useEffect, useState } from 'react';
import AdminLayout from '@/components/layout/AdminLayout';
import { adminApi, Card, Badge } from './_shared';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export default function AdminModules() {
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => { setLoading(true); try { const r = await adminApi.modules(); setModules(r.modules || []); } finally { setLoading(false); } };
  useEffect(() => { load(); }, []);

  const toggle = async (m, key) => {
    try { await adminApi.updateModule(m.moduleCode, { [key]: !m[key] }); toast.success(`Updated ${m.moduleCode}`); load(); }
    catch (err) { toast.error(err.response?.data?.detail || 'Failed'); }
  };

  return (
    <AdminLayout title="Module Registry" subtitle="Admin · Platform Modules">
      <p className="text-sm text-slate-400 mb-6 max-w-3xl">
        Toggle which modules are visible across all projects, mark certain modules as mandatory (cannot be deactivated by project admins),
        and control whether they appear by default when creating new projects.
      </p>
      {loading && modules.length === 0 ? (
        <div className="flex items-center justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-slate-500"/></div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4" data-testid="modules-grid">
          {modules.map((m) => (
            <Card key={m.moduleCode} className="p-5">
              <div className="flex items-start justify-between gap-3 mb-3">
                <div className="min-w-0">
                  <div className="text-[10px] tracking-[0.2em] text-slate-500 uppercase">{m.tier || m.category || 'Module'}</div>
                  <h3 className="text-base text-slate-100 font-medium mt-0.5 truncate">{m.sidebarLabel || m.moduleName || m.moduleCode}</h3>
                  <div className="text-[11px] text-slate-500 font-mono">{m.moduleCode}</div>
                </div>
                <Badge tone={m.isVisible !== false ? 'green' : 'slate'}>{m.isVisible !== false ? 'Visible' : 'Hidden'}</Badge>
              </div>
              {m.description && <p className="text-xs text-slate-400 mb-4 line-clamp-2">{m.description}</p>}
              <div className="grid grid-cols-3 gap-2 mt-4 pt-4 border-t border-slate-800/40">
                {[
                  ['isVisible',     'Visible'],
                  ['isMandatory',   'Mandatory'],
                  ['defaultEnabled','Default On'],
                ].map(([k, lbl]) => (
                  <button key={k} onClick={() => toggle(m, k)} data-testid={`mod-${m.moduleCode}-${k}`}
                    className={`text-[11px] py-2 rounded border transition ${
                      m[k] ? 'border-[#1E4E8C] bg-[#1E4E8C]/20 text-slate-100' : 'border-slate-800 text-slate-500 hover:text-slate-300'
                    }`}>
                    {m[k] ? '● ' : '○ '}{lbl}
                  </button>
                ))}
              </div>
            </Card>
          ))}
        </div>
      )}
    </AdminLayout>
  );
}
